export default __webpack_public_path__ + "static/19_36-8f9b0d1eb420ec07dbc8aaedfcb072c8.png";